import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { IElement, IGuide } from 'common/interfaces';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { useCallback, useEffect } from 'react';
import {
  IBreakpoint,
  addBreakpoints,
  updateArtboardPropsWhenBreakpointChanged,
} from 'store/reducers/common.slice';
import { updateElemsWhenBreakpointChanged } from 'store/reducers/elems.slice';
import { updateGuidesWhenBreakpointChanged } from 'store/reducers/guides.slice';

interface IUseBreakpoints {
  addNewBreakpoint: (artboardWidth: number) => void;
}

export default function useBreakpoints(
  elems: IElement[],
  guides: IGuide[],
  dispatch: Dispatch<AnyAction>,
): IUseBreakpoints {
  const artboardProps = useTypedSelector((state) => state.common.artboardProps);
  const activeBreakpoint = useTypedSelector(
    (state) => state.common.activeBreakpoint,
  );
  const breakpoints = useTypedSelector((state) => state.common.breakpoints);

  const addNewBreakpoint = useCallback(
    (artboardWidth: number): void => {
      const breakpointData: IBreakpoint = {
        breakpoint: artboardWidth,
        elems,
        guides,
        artboardProps,
      };

      const newBreakpoints = [breakpointData];

      if (!breakpoints.length) {
        const zeroBreakpointData: IBreakpoint = {
          ...breakpointData,
          breakpoint: 0,
        };

        newBreakpoints.push(zeroBreakpointData);
      }

      dispatch(addBreakpoints(newBreakpoints));
    },
    [elems, guides, artboardProps, dispatch, breakpoints],
  );

  // обновляем коллекцию элементов и направляющих, если изменился брейкпоинт
  useEffect(() => {
    if (!activeBreakpoint) return;

    dispatch(updateElemsWhenBreakpointChanged(activeBreakpoint.elems));
    dispatch(updateGuidesWhenBreakpointChanged(activeBreakpoint.guides));
    dispatch(
      updateArtboardPropsWhenBreakpointChanged(activeBreakpoint.artboardProps),
    );
  }, [activeBreakpoint, dispatch]);

  return {
    addNewBreakpoint,
  };
}
